
import { selectOrdersByIds } from '@/entities/orders'
import { runsheetsSelectors } from '@/entities/schedules'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { getUnassignedRowFromOrder } from '../libs/getUnassignedRowFromOrder'
import { upsertOneRunsheetUnassignedTable } from '../slices/runsheetUnassignedTablesSlice'

type UpdateRunsheetUnassignedTablePayload = {
  runsheetId: EntityId
}

export const updateRunsheetUnassignedTableState = createAsyncThunk<void, UpdateRunsheetUnassignedTablePayload, { state: RootState }>(
  'runsheetUnassignedTable/update',
  async ({ runsheetId }, { getState, dispatch }) => {
    const state = getState()
    const runsheet = runsheetsSelectors.selectById(state, runsheetId)
    const runsheetOrderIds = runsheet?.unassignedOrders
    const orders = selectOrdersByIds(state, runsheetOrderIds)

    if (!orders) {
      throw new Error('Redux thunk error [runsheetUnassignedTable/update]: orders not found')
    }

    const rows = orders.map((order) => getUnassignedRowFromOrder(order, runsheetId))

    dispatch(upsertOneRunsheetUnassignedTable({
      runsheetId: runsheetId,
      runsheetName: runsheet?.name || '',
      isLoading: false,
      rows,
    }))
  },
)
